import axios from "@/api/axios"

export default {
	async getHeaderData() {
		try {
			const resp = await axios.get('/header')
			return {
				data: resp.data,
				status: resp.status
			}
		}
		catch (err: any) {
			return err.status
		}
	}
}
